import { Reveal, SectionHead } from "./Reveal";
import { mediaUrl } from "../../lib/site";

function initials(name) {
  return name
    .replace(/^(Col\.|Maj\.|Dr\.|Mr\.|Mrs\.|Ms\.)\s*/i, "")
    .split(" ")
    .map((p) => p[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

export default function Members({ members }) {
  return (
    <section id="members" className="bg-navy-900/50 py-20 lg:py-28" data-testid="members-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <SectionHead
          eyebrow="Our Kroonerz"
          title="Meet the Voices"
          sub="Eight of our featured singers — part of an ensemble of around sixteen active members, male and female, including trained vocalists."
        />
        <div className="mt-14 grid grid-cols-2 gap-5 sm:gap-6 lg:grid-cols-4">
          {members.map((m, i) => (
            <Reveal key={m.name} delay={0.05 * i}>
              <div className="tk-card group p-6 text-center transition-all duration-300 hover:-translate-y-1.5 hover:border-gold/40" data-testid={`member-card-${m.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                {m.photo ? (
                  <img src={mediaUrl(m.photo)} alt={m.name} loading="lazy" className="mx-auto h-28 w-28 rounded-full border border-gold/30 object-cover sm:h-32 sm:w-32" />
                ) : (
                  <div className="vinyl relative mx-auto h-28 w-28 transition-transform duration-500 group-hover:rotate-45 sm:h-32 sm:w-32" data-testid={`member-avatar-${i}`}>
                    <div className="absolute inset-0 m-auto flex h-12 w-12 items-center justify-center rounded-full bg-burgundy">
                      <span className="font-serif text-base font-bold text-gold-light">{initials(m.name)}</span>
                    </div>
                    <div className="absolute inset-0 m-auto h-1.5 w-1.5 rounded-full bg-ivory/70" />
                  </div>
                )}
                <h3 className="mt-5 font-serif text-lg font-semibold text-ivory">{m.name}</h3>
                {m.role && <p className="mt-1 text-xs font-semibold uppercase tracking-[0.16em] text-gold/80">{m.role}</p>}
                <p className="mt-2 text-[11px] uppercase tracking-[0.18em] text-slate-500">Krooner · Tricity</p>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.25}>
          <p className="mt-10 text-center text-xs uppercase tracking-[0.22em] text-slate-500">
            …and more voices in the ensemble · Photographs & profiles coming soon
          </p>
        </Reveal>
      </div>
    </section>
  );
}
